import axios from "axios";
import {EventBus} from "../../event-bus";

export default {
  namespaced: true,
  state: {
    loading: false,
    account: {
      id: auth.usergroup,
      name: auth.company
    },
    user: {
      id: auth.id,
      fullname: `${auth.firstname} ${auth.lastname}`
    },
    accountList: [],
    userList: [],
  },
  mutations: {
    setAccountList: function (state, accountList) {
      state.accountList = accountList;
    },
    setUserList: function (state, users) {
      state.userList = users;
    },
    setAccount (state, account) {
      state.account = account;
    },
    setUser (state, user) {
      state.user = user;
    },
    setLoading (state, loading) {
      if (loading) {
        EventBus.$emit('loader:show');
      }
      else {
        EventBus.$emit('loader:hide');
      }
      state.loading = loading;
    },
  },
  actions: {
    async loadAccountData ({commit}, accDataUrl) {
      return axios.get(accDataUrl).then(res => {
          commit('setAccountList', res.data);
        }
      );
    },
    async loadViewableUsers ({commit}) {
      return axios.get(`permissions/can-view/users`).then(res => {
          commit('setUserList', res.data.data);
        }
      );
    },
  }
};
